import { FC, memo } from 'react'
import clsx from 'clsx'
import { ChevronDownIcon, CrossIcon } from '@/assets'
import { Chip } from '@/components/Data'
import { filterChipClasses } from './FilterChip.data'
import { filterChipStyles as styles } from './FilterChip.styles'
import { TicketFilterChipProps } from './FilterChip.types'

const FilterChip: FC<TicketFilterChipProps> = ({
  label,
  isActive,
  enableClear = true,
  onClick,
  onClear,
}) => {
  return (
    <Chip
      sx={styles.chip}
      color="default"
      label={label}
      className={clsx({ [filterChipClasses.active]: isActive })}
      onClick={onClick}
      onDelete={() => {
        if (enableClear && isActive) {
          onClear?.()
        } else {
          onClick()
        }
      }}
      deleteIcon={enableClear && isActive ? <CrossIcon /> : <ChevronDownIcon />}
    />
  )
}

export default memo(FilterChip)
